var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2895 8.45733L5.63955 14.1173C5.54582 14.2103 5.47143 14.3209 5.42066 14.4428C5.36989 14.5646 5.34375 14.6953 5.34375 14.8273C5.34375 14.9593 5.36989 15.0901 5.42066 15.2119C5.47143 15.3338 5.54582 15.4444 5.63955 15.5373C5.82691 15.7236 6.08036 15.8281 6.34455 15.8281C6.60873 15.8281 6.86219 15.7236 7.04955 15.5373L12.0495 10.5873L16.9995 15.5373C17.1869 15.7236 17.4404 15.8281 17.7045 15.8281C17.9687 15.8281 18.2222 15.7236 18.4095 15.5373C18.504 15.4447 18.5792 15.3343 18.6307 15.2124C18.6822 15.0905 18.709 14.9596 18.7095 14.8273C18.709 14.695 18.6822 14.5641 18.6307 14.4423C18.5792 14.3204 18.504 14.2099 18.4095 14.1173L12.7595 8.45733C12.6659 8.35583 12.5523 8.27482 12.4258 8.21941C12.2993 8.164 12.1627 8.1354 12.0245 8.1354C11.8864 8.1354 11.7498 8.164 11.6233 8.21941C11.4968 8.27482 11.3832 8.35583 11.2895 8.45733Z",
    fill: "#3D3D3D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/up.b08e75535a72bd316d615690a01a13cc.svg";